<p-dataView [value]="canvas.menuItems">
	<ng-template pTemplate="header">
		<div class="d-flex flex-column w-100">
			<div class="h3">{{ canvas.displayName || canvas.name }}</div>
			<div class="product-description">
				{{ canvas.description }}
			</div>
		</div>
	</ng-template>
	<ng-template let-item pTemplate="listItem">
		<div
			class="p-col-12 p-md-6"
			[style.background-color]="venueService.ooVenue.styles?.canvasItemCellBgColor"
			style="border-width: 3px"
			[style.border-color]="venueService.ooVenue.styles?.canvasItemBorderColor"
		>
			<app-subscription-menu-item [canvasMenuItem]="item" (selectedItemChange)="selectedItem = $event"></app-subscription-menu-item>
		</div>
	</ng-template>
</p-dataView>

<app-subscription-menu-item-selected *ngIf="selectedItem" [(selectedItem)]="selectedItem"></app-subscription-menu-item-selected>
